/**
 * Compares a quick-filter link's URL against the current page URL to decide
 * whether that filter is the one currently applied.
 * @param {string} href
 * @param {string} currentHref
 * @returns {boolean}
 */
export function isActiveFilterHref(href, currentHref) {
  const current = new URL(currentHref);
  const target = new URL(href, current);
  return target.pathname === current.pathname && target.search === current.search;
}

class QuickFiltersComponent extends HTMLElement {
  connectedCallback() {
    for (const link of this.querySelectorAll('.quick-filter')) {
      link.classList.toggle('is-active', isActiveFilterHref(link.href, window.location.href));
    }
  }
}

if (!customElements.get('quick-filters-component')) {
  customElements.define('quick-filters-component', QuickFiltersComponent);
}
